import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-national-taco-day',
  templateUrl: './national-taco-day.component.html',
  styleUrls: ['./national-taco-day.component.scss']
})
export class NationalTacoDayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/national-taco-day/national-taco-day.component.ts